import add from './entry/add'
import check from './entry/check'
import subscribe from './entry/subscribe'
export default {add,check,subscribe}
